module.exports = __webpack_public_path__ + "static/media/nginx-waf.c09f422b.png";